<header>
  <div class="logo">
    <a href="/">
      <img src="../../../../assets/images/AnotherLogo.png" class="logoImg" />
    </a>
  </div>
  <div class="test-net d-none d-sm-flex" *ngIf="connected">
    <p class="dot"></p>
    <p>Live {{ networkName }}</p>
  </div>
  <p
    class="bondsBtn"
    (click)="bondsPage()"
    *ngIf="signedIn && !onIndiaLendPage"
  >
    Bonds
  </p>
  <p
    class="bondsBtn"
    (click)="showProfile(completeProfileModel)"
    *ngIf="signedIn && onIndiaLendPage"
  >
    Profile
  </p>
  <ng-template #completeProfileModel let-modal>
    <div class="modal-body" style="padding: 30px 15px">
      <div class="form-group">
        <div id="signInUsingOTP">
          <div class="">
            <div class="top-icon">
              <!-- <img
                src="../../../../../assets/upload.png"
                style="width: 50px; margin-bottom: 10px"
              /> -->
            </div>

            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              (click)="close()"
              style="
                width: 0px;
                margin-left: 85%;
                margin-top: -30px;
                position: absolute;
                border: none;
              "
            ></button>

            <h1 class="ltyaccount">Profile</h1>

            <div class="container">
              <div class="row">
                <div class="col-md-6" *ngIf="userProfileData?.name">
                  <p class="asdoiytiy">Name :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.name }}"
                  />

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.email">
                  <p class="asdoiytiy">Email :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.email }}"
                  />

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.phoneNo">
                  <p class="asdoiytiy">Phone No. :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.phoneNo }}"
                  />

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.aadharNo">
                  <p class="asdoiytiy">Aadhar Number :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.aadharNo }}"
                  />

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.ePan">
                  <p class="asdoiytiy">Pan Number :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.ePan }}"
                  />

                  <br />
                </div>
                <div
                  class="col-md-6"
                  *ngIf="userProfileData?.address?.addressl1"
                >
                  <p class="asdoiytiy">Address Line 1 :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.address?.addressl1 }}"
                  />

                  <br />
                </div>
                <div
                  class="col-md-6"
                  *ngIf="userProfileData?.address?.addressl2"
                >
                  <p class="asdoiytiy">Address Line 2 :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.address?.addressl2 }}"
                  />

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.address?.city">
                  <p class="asdoiytiy">City :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.address?.city }}"
                  />

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.address?.state">
                  <p class="asdoiytiy">State :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.address?.state }}"
                  />

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.address?.pincode">
                  <p class="asdoiytiy">Pin Code :</p>
                  <input
                    type="text"
                    readonly
                    name="aadharNumber"
                    value="{{ userProfileData?.address?.pincode }}"
                  />

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.aadharUrl">
                  <p class="asdoiytiy">Aaddhar Card Link :</p>
                  <label for="file">
                    <a href="{{ userProfileData.aadharUrl }}" target="_blank">
                      <i class="fa fa-external-link" aria-hidden="true"></i>
                    </a>
                  </label>

                  <br />
                </div>
                <div class="col-md-6" *ngIf="userProfileData?.panUrl">
                  <p class="asdoiytiy">Pan Card Link :</p>
                  <label for="file">
                    <a href="{{ userProfileData.panUrl }}" target="_blank">
                      <i class="fa fa-external-link" aria-hidden="true"></i>
                    </a>
                  </label>

                  <br />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="logout" *ngIf="signedIn && onIndiaLendPage">
    <button class="logoutBtn" (click)="logout()">Logout</button>
  </div>

  <div class="connect" *ngIf="showWalletBtn && !onIndiaLendPage">
    <button
      id="connect-btn"
      data-bs-toggle="modal"
      data-bs-dismiss="modal"
      data-bs-target="#connectModal"
      *ngIf="!connected || walletAddress == null || walletAddress == undefined"
    >
      Connect <span>Wallet</span>
    </button>
    <button
      id="connect-btn"
      data-bs-toggle="modal"
      data-bs-dismiss="modal"
      *ngIf="connected && networkDiff"
      (click)="addNetworkToWallet()"
    >
      Switch To <span>Polygon</span>
    </button>
  </div>
</header>

<!-- not connected -->
<div
  class="modal fade"
  id="connectModal"
  tabindex="-1"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <img src="../../../../../assets/images/purse.png" />
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body" id="connecting">
        <h3 id="h3">Choose Wallet</h3>
        <button id="meta" (click)="connectMetamask()">
          <img src="../../../../../assets/images/metamask.png" />
          <span>MetaMask</span>
        </button>

        <button id="wallet" (click)="walletConnect()">
          <img src="../../../../../assets/images/walletconnect.png" />
          <span>WalletConnect</span>
        </button>

        <p id="more"></p>
        <!-- <p id="dash"></p>
        <h4>Don't have a wallet?</h4>
        <a href="">Create Wallet</a> -->
      </div>
    </div>
  </div>
</div>
<div class="test-net d-sm-none d-flex" style="margin-left: 20px">
  <p class="dot"></p>
  <p>Live {{ networkName }}</p>
</div>
